var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "section general-list-block",
      class: {
        "general-list-blockTs": _vm.brandName === _vm.Brand.Travelsphere,
      },
    },
    [
      _c("div", { staticClass: "full-width" }, [
        _c("div", { staticClass: "container-fluid" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col" }, [
              _c(
                "ol",
                { staticClass: "card-list" },
                _vm._l(_vm.items, function (item) {
                  return _c(
                    "li",
                    { key: item.id, staticClass: "card-list__item no-opacity" },
                    [
                      _c("article", { staticClass: "card js-card" }, [
                        _c("div", { staticClass: "card__img-holder" }, [
                          _c("picture", [
                            _c("img", {
                              staticClass: "card__img img-responsive lazyload",
                              attrs: {
                                src: `${item.image.largeUrl}?format=webp`,
                                alt: item.image.altText,
                                loading: "lazy",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          item.tourSummary.offerText
                            ? _c("div", { staticClass: "offer-tag" }, [
                                _vm._v(_vm._s(item.tourSummary.offerText)),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "card__content" }, [
                          _c("div", { staticClass: "card__inner" }, [
                            _c("div", { staticClass: "card__header" }, [
                              _c("h3", { staticClass: "card__title" }, [
                                _vm._v(_vm._s(item.name)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "card__description" }, [
                              _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(item.description),
                                },
                              }),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "tour-price" }, [
                            _c("div", { staticClass: "tour-price__days" }, [
                              _c("strong", [
                                _vm._v(
                                  _vm._s(item.tourSummary.fromDays) + " days"
                                ),
                              ]),
                              _vm._v(" from"),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "tour-price__value" }, [
                              _vm._v(
                                _vm._s(item.tourSummary.fromPriceFormatted)
                              ),
                            ]),
                            _vm._v(" "),
                            item.tourSummary.hasWasFromPrice
                              ? _c(
                                  "div",
                                  { staticClass: "tour-price__was-value" },
                                  [
                                    _vm._v("was "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          item.tourSummary.wasPriceFormatted
                                        )
                                      ),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass: "btn card__btn",
                              attrs: {
                                href: item.url,
                                "aria-label": "Explore",
                              },
                            },
                            [_vm._v("Explore")]
                          ),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "cta-holder" }, [
                _vm.itemsRemaining > 0
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn--alt",
                        attrs: {
                          "aria-label": _vm.loadMoreButtonText,
                          title: _vm.loadMoreButtonText,
                        },
                        on: { click: _vm.loadMore },
                      },
                      [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.loadMoreButtonText) +
                            "\n                        "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                this.totalPages > 1
                  ? _c("div", { staticClass: "pt-20" }, [
                      _c("strong", [
                        _vm._v(
                          _vm._s(
                            _vm.take > _vm.itemsCount
                              ? _vm.itemsCount
                              : _vm.take
                          )
                        ),
                      ]),
                      _vm._v("  of "),
                      _c("strong", [_vm._v(_vm._s(this.itemsCount))]),
                      _vm._v(" tours\n                        "),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }